import tmsIndentAxiosInstance from '../../../tms-indent-axios';

const state = {
  validationStatus: null,
  isLoading: false,
};

const getters = {
  validationStatus: s => s.validationStatus,
  isLoading: s => s.isLoading,
};

const mutations = {
  SET_VALIDATION_STATUS(s, data) { s.validationStatus = data; },
  SET_LOADING(s, val) { s.isLoading = val; },
};

const actions = {
  async fetchStatus({ commit }, { orderNo }) {
    commit('SET_LOADING', true);
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${orderNo}/pod-validation-status`);
      commit('SET_VALIDATION_STATUS', result);
      return result;
    } catch (err) {
      return null;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async resubmit(_, { orderNo, destinationId }) {
    const result = await tmsIndentAxiosInstance.post(
      `/order/${orderNo}/destination/${destinationId}/pod/resubmit`,
      {},
    );
    return result.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
